import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Parametros from "../Parametros";
import Table from "../Table";
import UserTab from "../UserTab";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";

function Titulos(props) {
  // eslint-disable-next-line
  const [stateUptade, setStateUpdate] = useState(false);

  const { history } = props;
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [titulosState, setTitulosState] = useState([]);
  const [titulosStateUpdate, settitulosStateUpdate] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(true);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  // eslint-disable-next-line
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi +
          "debt_title_types?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setTitulosState(JSON.parse(responseJsonUpdate));
        settitulosStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, history, usuario]);

  const [formularioState, setFormularioState] = useState({
    name: "",
  });

  const [editable, setEditable] = useState({
    id: "",
  });

  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };

  let creartitulos = async (event) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "debt_title_types/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          setEditable({});
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let titulosHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = titulosState;
    newList[index][name] = value;
    setTitulosState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  // eslint-disable-next-line
  let confirmarEliminacion = () => {
    const nuevoObjeto = JSON.parse(JSON.stringify(titulosState));
    settitulosStateUpdate(nuevoObjeto);
    setStateUpdate(false);
  };
  // eslint-disable-next-line
  let cancelarEliminacion = () => {
    // eslint-disable-next-line
    const nuevoObjeto = JSON.parse(JSON.stringify(titulosStateUpdate));
    // settitulosState(nuevoObjeto)
    setStateUpdate(false);
  };

  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi + "debt_title_types/" + item.title_type_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          setEditable({});
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          setUpdate(!update);
          alert(response.detail);
          setEditable({});
          document.getElementById("formularioBusqueda").reset();
        }
      } else {
        // Do nothing!
        setEditable({});
        setTitulosState(JSON.parse(JSON.stringify(titulosStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };
  let editar = (id) => {
    setTitulosState(JSON.parse(JSON.stringify(titulosStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setTitulosState(JSON.parse(JSON.stringify(titulosStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Titulos"}></UserTab>
        <form id="formularioBusqueda">
          <div className="col-md-4">
            <h5>Nombre titulos</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="button"
              onClick={(e) => {
                creartitulos(e);
              }}
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>
        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(titulosState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Descripcion"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Descripcion"]}></Table>
            {!usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {titulosState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.title_type_id}>
                      {editable === item.title_type_id ? (
                        <>
                          <td>{item.title_type_id}</td>

                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                titulosHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.title_type_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.title_type_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`debt_title_type/${item.title_type_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(titulosState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Titulos);
